<template>
  <div>
    <div class="row">
      <div class="col-sm-12 padding-top">
        <div class="panel panel-default">
          <div
            class="panel-heading"
            @click.prevent="collapsed = !collapsed"
            style="cursor: pointer;"
          >
            <a href="#"
              ><i class="fa" :class="{ 'fa-plus': collapsed, 'fa-minus': !collapsed }"></i> Regime
              Estadual
              <span v-if="pendencias > 0" class="badge bg-red">{{
                pendencias | pluralize('pendência')
              }}</span></a
            >
          </div>
          <div class="panel-body" v-show="!collapsed">
            <div class="row">
              <div class="col-sm-12">
                <strong>Regime/Vigência</strong>
              </div>
              <hr />
            </div>
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group" :class="{ 'has-error': $v.estadual.tipo.$invalid }">
                  <label for="">Regime:</label>
                  <multiselect
                    :options="regimesEstaduais"
                    :block-keys="['Tab', 'Enter']"
                    @select="onSelectRegime"
                    label="descricao"
                    track-by="id"
                    v-model="estadual.tipo"
                    :allow-empty="false"
                    placeholder="Selecione um regime"
                    selectLabel="Selecionar"
                    selectedLabel="Selecionado"
                    deselect-label=""
                    :disabled="$parent.disableAll"
                  ></multiselect>
                  <p class="help-block" v-show="!$v.estadual.tipo.descricao.required">
                    Este campo é obrigatório.
                  </p>
                </div>
              </div>
              <div
                class="col-sm-2 my-popover"
                data-content="A Vigência só pode ser alterada após a alteração do Regime"
                data-toggle="popover"
              >
                <div class="form-group" :class="{ 'has-error': $v.estadual.vigencia.$invalid }">
                  <label for="">Data Vigência:</label>
                  <input-data v-model="estadual.vigencia" :disabled="$parent.disableAll" />
                  <p class="help-block" v-show="!$v.estadual.vigencia.required">
                    Este campo é obrigatório.
                  </p>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Carga Média:</label>
                  <input-money v-model="estadual.cargaMedia" prefix="" :disabled="true" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">Fundo Pobreza:</label>
                  <input-money v-model="estadual.fundoPobreza" prefix="" :disabled="true" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="">MVA:</label>
                  <input-money v-model="estadual.mva" prefix="" :disabled="true" />
                </div>
              </div>
            </div>
            <div class="row" v-if="isNovo">
              <div class="col-sm-12">
                <button
                  class="btn btn-success pull-right"
                  :disabled="pendencias > 0"
                  @click.prevent="updateRegimeEstadual"
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RegimeEstadualValidation, RegimeEstadualNoValidation } from '../../models/RegimeEstadual'
import EmpresaService from '../../services/EmpresaService.js'
import { Empresa } from '../../models/Empresa'
import RegimeService from '../../services/RegimeService'
import Multiselect from 'vue-multiselect'
import InputMoney from '../../components/Inputs/InputMoney.vue'
import InputData from '../../components/Inputs/InputData.vue'

export default {
  name: 'regime-estadual',
  props: {
    value: {},
    isNovo: {
      type: Boolean,
      required: true
    },
    ativo: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      estadual: new Empresa().regime.estadual,
      collapsed: true,
      regimesEstaduais: [],
      firstWatch: true,
      meuzovo: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.$('.my-popover').popover({
        placement: 'top',
        html: true,
        container: 'body',
        trigger: 'hover'
      })
    })
    this.estadual = this.value.regime.estadual
    this.retrieveRegimesEstaduais()
  },
  methods: {
    async updateRegimeEstadual() {
      try {
        let empresa = Object.assign({}, this.value)
        empresa.regime.federal = {}
        empresa.regime.estadual = this.estadual
        empresa.contato = {}
        empresa.endereco = {}
        empresa.contabilista = {}
        await EmpresaService.update(empresa)
        this.$messages.success().toast('Empresa atualizada com sucesso!')
        this.$router.go(-1)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível realizar esta ação')
        console.error(e)
      } finally {
      }
    },

    async retrieveRegimesEstaduais() {
      try {
        const data = await RegimeService.retrieveRegimesEstaduais()
        this.regimesEstaduais = data.body
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast(e.data)
        console.error(e)
      }
    },

    onSelectRegime() {
      this.estadual.status = 'INSERT'
      this.estadual.vigencia = ''
    }
  },
  components: {
    Multiselect,
    InputMoney,
    InputData
  },
  computed: {
    pendencias() {
      return Object.entries(this.$v.estadual)
        .map(a => a[1])
        .filter(a => a.$invalid).length
    }
  },
  watch: {
    estadual: {
      handler: function() {
        if (this.firstWatch) {
          this.firstWatch = false
        } else {
          this.estadual.status = 'INSERT'
        }
      },
      deep: true
    },

    value(vl) {
      this.estadual = vl.regime.estadual
    }
  },
  validations() {
    return {
      estadual: this.ativo ? RegimeEstadualValidation : RegimeEstadualNoValidation
      // empresa: {
      //   regime: {
      //     estadual: this.empresa.ativo ? RegimeEstadualValidation : RegimeEstadualNoValidation
      //   }
      // }
    }
  }
}
</script>

<style lang="css" scoped>
a {
  color: #3c8dbc !important;
}
</style>
